import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { fetchHighlightPlans } from '../../../apiCalls';

import Loading from '../../../components/standard/loading/Loading';
import InfosMobile from '../infos_mobile/InfosMobile';
import FilterWrapper from './Filters/FilterWrapper';
import ActiveFilters from './Filters/ActiveFilters';
import PlansListing from './PlansListing';
import SpecialistBlock from './SpecialistBlock';
import Plan from './Plan';
import HighligthPlans from './HighligthPlans';

import { calcCouponDiscount, maxValueParcel as planMaxValueParcel } from '../../../utils/plan';

import { getProductInfo } from '../../../actions/coverageActions';
import {
  filterPlans,
  setSortOption,
  setProviderFilter,
  addComparisonPlan,
  setQuotationParams,
  removeComparisonPlan,
  filterPlansMobile,
  openModalQuotationDateWarning,
  openModalFilterCategory,
  clearFilterCategories,
  unselectFilterCategoryOptions,
  storeHighligthPlans,
} from '../../../actions/searchActions';

import { formatURL, cleanDate, maxValueParcel } from '../../../utils';

function PlansTableWrapper(props) {
  return <PlansTable {...props} />;
}

class PlansTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      originalHighlightPlans: [],
    };

    this.setProviderFilter = this.setProviderFilter.bind(this);
    this.setSortOption = this.setSortOption.bind(this);

    this.addComparisonPlan = this.addComparisonPlan.bind(this);
    this.changeLocation = this.changeLocation.bind(this);
    this.goToSearchPage = this.goToSearchPage.bind(this);

    this.setQuotationParams = this.props.setQuotationParams.bind(this);

    this.handleUnselectFilterCategory = this.handleUnselectFilterCategory.bind(this);
    this.handleClearAllFilterCategory = this.handleClearAllFilterCategory.bind(this);
  }

  processHighlightPlans = (plans) => {
    return plans.map((plan) => {
      const priceWithDiscount = calcCouponDiscount(plan, this.props.coupon);
      const finalPrice = priceWithDiscount || plan.price.adult.price;

      return {
        ...plan,
        price_with_coupon_discount: priceWithDiscount,
        parcels: planMaxValueParcel(finalPrice),
      };
    });
  };

  reprocessHighlightPlansWithCoupon = () => {
    if (this.state.originalHighlightPlans.length > 0) {
      const processedPlans = this.processHighlightPlans(this.state.originalHighlightPlans);
      this.props.storeHighligthPlans(processedPlans);
    }
  };

  loadHighlightPlans = async () => {
    try {
      const highlightPlans = await fetchHighlightPlans(this.props.match.params);

      this.setState({ originalHighlightPlans: highlightPlans });

      const processedPlans = this.processHighlightPlans(highlightPlans);
      this.props.storeHighligthPlans(processedPlans);
    } catch (error) {
      console.error('Erro ao carregar planos em destaque:', error);
    }
  };

  componentDidMount() {
    this.loadHighlightPlans();

    this.setQuotationParams({
      begin_date: cleanDate(this.props.match.params.begin_date),
      end_date: cleanDate(this.props.match.params.end_date),
      destination: this.props.match.params.destination,
      context: 'search',
      benefits: ['51', '42', '57', '55', '45', '68', '69'],
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.coupon !== this.props.coupon) {
      this.reprocessHighlightPlansWithCoupon();
    }

    // Fix footer position for desktop only when comparison plans bottomsheet
    if (!this.props.mobile && this.props.comparisonPlans && this.props.comparisonPlans.length > 0) {
      const compFooter = document.getElementsByClassName('comp_footer hide-mobile');
      if (compFooter && compFooter.length) {
        compFooter[0].style = 'padding-bottom: 150px';
      }
    } else {
      // rollback footer position
      const compFooter = document.getElementsByClassName('comp_footer hide-mobile');
      if (compFooter && compFooter.length) {
        compFooter[0].style = '';
      }
    }
  }

  setProviderFilter(value) {
    this.props.setProviderFilter(value);
    this.props.filterPlans();
  }

  setSortOption(value) {
    this.props.setSortOption(value);
    this.props.filterPlans();
  }

  goToSearchPage() {
    this.props.history.push('/site');
  }

  addComparisonPlan(plan) {
    const equalPlans = this.props.comparisonPlans.filter((comparisonPlan) => comparisonPlan.code === plan.code);

    if (equalPlans.length > 0) this.props.removeComparisonPlan(plan.code);
    else if (this.props.comparisonPlans.length < 4) this.props.addComparisonPlan(plan);
  }

  changeLocation(location) {
    this.props.history.push(formatURL(this.props.match.params, location.pathname));
  }

  handleClearAllFilterCategory() {
    let newUrlParams = '';
    let location = '';
    let searchParams = window.location.search.replace('?', '').split('&');

    searchParams = searchParams.filter(
      (oldCategory) => !oldCategory.includes('category=') && !oldCategory.includes('provider=')
    );

    searchParams.forEach((param, index) => {
      if (param === '') return;
      newUrlParams += index > 0 ? `&${param}` : `?${param}`;
    });

    if (newUrlParams !== '') {
      location = newUrlParams;
    } else {
      location = window.location.pathname;
    }

    this.props.clearFilterCategories();
    window.history.replaceState(null, null, location);
  }

  handleUnselectFilterCategory(type_category, category_index, option_index = 0) {
    const searchParams = window.location.search.replace('?', '').split('&');
    let newUrl = '';

    if (type_category === 'category') {
      const categorySelected = this.props.filterCategory[category_index].Categories[option_index].ID;
      let newCategoryParam = searchParams.find((param) => param.includes('category=')) || '';

      if (newCategoryParam) {
        if (newCategoryParam === `category=${categorySelected}`) {
          newCategoryParam = '';
        } else if (newCategoryParam.endsWith(`,${categorySelected}`)) {
          newCategoryParam = newCategoryParam.replace(`,${categorySelected}`, '');
        } else {
          newCategoryParam = newCategoryParam.replace(`${categorySelected},`, '');
        }
      }

      const otherParams = searchParams.filter((param) => !param.includes('category=') && param !== '');
      const allParams = newCategoryParam ? [...otherParams, newCategoryParam] : otherParams;
      newUrl = allParams.length > 0 ? `?${allParams.join('&')}` : window.location.pathname;
    } else if (type_category === 'provider') {
      const providerSelected = this.props.filterProvider[category_index].slug;
      let newProviderParam = searchParams.find((param) => param.includes('provider=')) || '';

      if (newProviderParam) {
        if (newProviderParam === `provider=${providerSelected}`) {
          newProviderParam = '';
        } else if (newProviderParam.endsWith(`,${providerSelected}`)) {
          newProviderParam = newProviderParam.replace(`,${providerSelected}`, '');
        } else {
          newProviderParam = newProviderParam.replace(`${providerSelected},`, '');
        }
      }

      const otherParams = searchParams.filter((param) => !param.includes('provider=') && param !== '');
      const allParams = newProviderParam ? [...otherParams, newProviderParam] : otherParams;
      newUrl = allParams.length > 0 ? `?${allParams.join('&')}` : window.location.pathname;
    }

    this.props.unselectFilterCategoryOptions(type_category, category_index, option_index);
    window.history.replaceState(null, null, newUrl);
  }

  render() {
    const selectedPlans = (this.props.comparisonPlans || []).map((plan) => plan.code);

    if (this.props.loading) return <Loading />;

    const filteredPlans = maxValueParcel(this.props.filtered_plans || []);

    const suggestedPlans = maxValueParcel(this.props.suggestions_plans || []);

    return (
      <section className="resultado-filtro">
        <InfosMobile destinations={this.props.destinations} />

        <HighligthPlans
          mobile={this.props.mobile}
          providers={this.props.providers}
          match={this.props.match}
          selectedPlans={selectedPlans}
          addComparisonPlan={this.addComparisonPlan}
          userDetails={this.props.userDetails}
          plans={this.props.highlightPlans}
        />

        <div className="component">
          <div>
            <div className="filter-specialist-wrapper">
              <FilterWrapper
                providers={this.props.providers}
                sortOptions={this.props.sortOptions}
                sort_option={this.props.sort_option}
                selectedSortOption={this.props.sort_option}
                setSortOption={this.setSortOption}
                setProviderFilter={this.setProviderFilter}
                mobile={this.props.mobile}
                provider={this.props.providerOption}
                openModalFilterCategory={this.props.openModalFilterCategory}
                handleClearAllFilterCategory={this.handleClearAllFilterCategory}
                handleUnselectFilterCategory={this.handleUnselectFilterCategory}
                filterCategory={this.props.filterCategory}
                filterProvider={this.props.filterProvider}
                settings={this.props.settings}
                plansLength={(this.props.filtered_plans && this.props.filtered_plans.length) || 0}
              />
              <SpecialistBlock />
            </div>

            {!this.props.mobile && (
              <ActiveFilters
                filterCategory={this.props.filterCategory}
                filterProvider={this.props.filterProvider}
                handleUnselectFilterCategory={this.handleUnselectFilterCategory}
                handleClearAllFilterCategory={this.handleClearAllFilterCategory}
                variant="v1"
              />
            )}
          </div>

          <React.Fragment>
            {filteredPlans.length === 0 && suggestedPlans.length > 0 && (
              <React.Fragment>
                <div className="filter-box-not-found">
                  <span className="ops">Ops!</span>
                  <span>
                    Não há planos com a combinação de filtro selecionada para esta
                    <br /> viagem, tente outra combinação.
                  </span>
                </div>

                <div className="suggestion-plans-box">
                  <span>Talvez você se interesse por estas opçôes:</span>
                </div>

                {suggestedPlans.map((plan, i) => (
                  <Plan
                    plan={plan}
                    key={plan.code}
                    match={this.props.match}
                    changeLocation={this.changeLocation}
                    getProductInfo={this.props.getProductInfo}
                    addComparisonPlan={this.addComparisonPlan}
                    history={this.props.history}
                    isSelected={selectedPlans.indexOf(plan.code.toString()) >= 0}
                    mobile={this.props.mobile}
                    mobileActive={() => this.props.mobileActive()}
                    openModalQuotationDateWarning={() => this.props.openModalQuotationDateWarning()}
                    userDetails={this.props.userDetails}
                    position={i}
                    providers={this.props.providers}
                    showSpecialistSuggestions={this.props.showSpecialistSuggestions}
                  />
                ))}
              </React.Fragment>
            )}

            {filteredPlans[0] !== undefined && (
              <PlansListing
                filteredPlans={filteredPlans}
                selectedPlans={selectedPlans}
                match={this.props.match}
                changeLocation={this.changeLocation}
                getProductInfo={this.props.getProductInfo}
                addComparisonPlan={this.addComparisonPlan}
                history={this.props.history}
                mobile={this.props.mobile}
                mobileActive={() => this.props.mobileActive()}
                openModalQuotationDateWarning={() => this.props.openModalQuotationDateWarning()}
                userDetails={this.props.userDetails}
                providers={this.props.providers}
                showSpecialistSuggestions={this.props.showSpecialistSuggestions}
              />
            )}
          </React.Fragment>
        </div>
      </section>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      plans: state.search.plans,
      loading: state.search.loading,
      end_date: state.search.end_date,
      providers: state.search.providers,
      begin_date: state.search.begin_date,
      destination: state.search.destination,
      sortOptions: state.search.sortOptions,
      sort_option: state.search.sort_option,
      filtered_plans: state.search.filtered_plans,
      suggestions_plans: state.search.suggestions_plans,
      comparisonPlans: state.search.comparisonPlans,
      searchState: state.search.searchState,
      mobile: state.mobile.mobileActive,
      userDetails: state.search.userDetails,
      providerOption: state.search.provider_option,
      filterCategory: state.search.filterCategory,
      filterProvider: state.search.filterProvider,
      highlightPlans: state.search.highlightPlans,
      benefits: state.purchase.benefits,
      coupon: state.purchase.coupon,
      showSpecialistSuggestions: state.search.showSpecialistSuggestions,
    }),
    {
      filterPlans,
      setSortOption,
      getProductInfo,
      setProviderFilter,
      addComparisonPlan,
      setQuotationParams,
      removeComparisonPlan,
      filterPlansMobile,
      openModalQuotationDateWarning,
      openModalFilterCategory,
      clearFilterCategories,
      unselectFilterCategoryOptions,
      storeHighligthPlans,
    }
  )(PlansTableWrapper)
);



// WEBPACK FOOTER //
// ./src/components/search/plans_table/PlansTable.jsx